export default __webpack_public_path__ + "static/media/STEMadium_WebInstructions_2.644306f7.png";